// Get the modal
var modal = document.getElementById("pdpDetailModal");

// Get the button that opens the modal
var pdpDetailBtn = document.getElementById("pdpDetailBtn");

// Get the <span> element that closes the modal
var pdpDetailModalClose = document.getElementsByClassName(
  "pdpDetailModal-close"
)[0];

// When the user clicks the button, open the modal
if (pdpDetailBtn && modal) {
  pdpDetailBtn.onclick = function () {
    modal.style.display = "flex";
  };
}

// When the user clicks on <span> (x), close the modal
if (pdpDetailModalClose && modal) {
  pdpDetailModalClose.onclick = function () {
    modal.style.display = "none";
  };
}

// When the user clicks anywhere outside of the modal, close it
if (modal) {
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
}
// Updates compare-at price and per-bottle price based on current
// variant and Skio subscription toggle state.
function updatePriceDisplay() {
  var productForm = document.querySelector('.product__form[data-product-form]');
  if (!productForm) return;

  var masterSelect = productForm.querySelector('.master_selection');
  if (!masterSelect) return;

  var selectedOption = masterSelect.options[masterSelect.selectedIndex];
  if (!selectedOption) return;

  var isSubscribeSelected = document.querySelector(
    '.skio-group-container--subscribe.skio-group-container--selected'
  );

  // Update main price and compare-at price
  var priceEl = document.querySelector('.product__price-and-badge [data-product-price]');
  var compareEl = document.querySelector('.product__price-and-badge [data-compare-price]');
  var variantInput = productForm.querySelector('input[name="id"][data-productid]');
  var productJsonEl = document.querySelector('[data-product-json]');
  if (variantInput && productJsonEl) {
    var prod = JSON.parse(productJsonEl.textContent);
    var found = prod.variants && prod.variants.find(function(v) {
      return v.id === parseInt(variantInput.value);
    });
    if (found) {
      // Update ATC button price
      var atcPriceEl = document.querySelector('[data-add-to-cart-price]');
      if (atcPriceEl && found) {
        var atcPrice = isSubscribeSelected
          ? selectedOption.getAttribute('data-sub-val')
          : '$' + (found.price / 100).toFixed(2);
        atcPriceEl.innerHTML = atcPrice
          ? '<span class="money">' + atcPrice + '</span>'
          : '<span class="money">$' + (found.price / 100).toFixed(2) + '</span>';
      }

      if (priceEl) {
        if (isSubscribeSelected) {
          var subVal = selectedOption.getAttribute('data-sub-val');
          priceEl.innerHTML = subVal
            ? '<span class="money">' + subVal + '</span>'
            : '<span class="money">$' + (found.price / 100).toFixed(2) + '</span>';
        } else {
          priceEl.innerHTML = '<span class="money">$' + (found.price / 100).toFixed(2) + '</span>';
        }
        if (found.compare_at_price && found.compare_at_price > found.price) {
          priceEl.classList.add('product__price--sale');
        } else {
          priceEl.classList.remove('product__price--sale');
        }
      }
      if (compareEl) {
        if (isSubscribeSelected) {
          compareEl.innerHTML = '<span class="money">$' + (found.price / 100).toFixed(2) + '</span>';
          compareEl.classList.remove('hidden');
        } else {
          if (found.compare_at_price && found.compare_at_price > found.price) {
            compareEl.innerHTML = '<span class="money">$' + (found.compare_at_price / 100).toFixed(2) + '</span>';
            compareEl.classList.remove('hidden');
          } else {
            compareEl.innerHTML = '';
            compareEl.classList.add('hidden');
          }
        }
      }
    }
  }

  // Update per-bottle price - read attributes directly, no jQuery
  var perBottlePrice = isSubscribeSelected
    ? selectedOption.getAttribute('data-per-bottle-subscription-price')
    : selectedOption.getAttribute('data-per-bottle-price');

  if (perBottlePrice) {
    var priceText = perBottlePrice.replace(/<[^>]*>/g, '');
    var existingSpan = document.querySelector('.per_bottle_price');
    if (existingSpan) existingSpan.remove();
    var priceWrapper = document.querySelector('.product__price-and-badge .product__price[data-price-wrapper]');
    if (priceWrapper) {
      var newSpan = document.createElement('span');
      newSpan.className = 'per_bottle_price';
      var unitLabel = document.querySelector('.product-single[data-per-unit-label]')?.getAttribute('data-per-unit-label') || 'bottle';
      newSpan.textContent = '(' + priceText + ' / ' + unitLabel + ')';
      priceWrapper.appendChild(newSpan);
    }
  }
}

(function() {
  function startObserving() {
    var debounceTimer = null;

    function runUpdate() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updatePriceDisplay, 50);
    }

    // Watch for Skio subscription toggle changes
    var skioContainer = document.querySelector('.selector-wrapper--qty');
    if (skioContainer) {
      var skioObserver = new MutationObserver(runUpdate);
      skioObserver.observe(skioContainer, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    }

   // Watch for variant changes via the hidden master_selection select
    var masterSelect = document.querySelector('.master_selection');
    if (masterSelect) {
      masterSelect.addEventListener('change', runUpdate);
    }

    // Hide price the instant user interacts with variant selectors
    document.querySelectorAll('.product-single [data-single-option-selector], .product-single [data-popout-option], .product-single .radio__input').forEach(function(el) {
      el.addEventListener('change', function() {
        var priceWrapper = document.querySelector('.product__price-and-badge .product__price[data-price-wrapper]');
        if (priceWrapper) priceWrapper.style.opacity = '0';
      });
      el.addEventListener('click', function() {
        var priceWrapper = document.querySelector('.product__price-and-badge .product__price[data-price-wrapper]');
        if (priceWrapper) priceWrapper.style.opacity = '0';
      });
    });

    document.addEventListener('theme:variant:change', function() {
      setTimeout(function() {
        runUpdate();
        var pw = document.querySelector('.product__price-and-badge .product__price[data-price-wrapper]');
        if (pw) {
          pw.style.transition = 'opacity 0.2s ease';
          pw.style.opacity = '1';
        }
      }, 50);
    });

    updatePriceDisplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();